"use client";
import React, { ReactNode } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

interface GoogleRecaptchaProps {
  children: ReactNode;
  sitekey: string;
}

const GoogleRecaptcha = ({ children, sitekey }: GoogleRecaptchaProps) => {
  if (!sitekey) {
    console.warn('Google ReCAPTCHA sitekey is not provided');
    return <>{children}</>;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={sitekey}
      scriptProps={{
        async: false,
        defer: false,
        appendTo: 'head',
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
};

export default GoogleRecaptcha;